import React from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models, Report } from 'powerbi-client';
import { APIContext } from '../Contexts/APIContext';
import "./PowerBi.css"
import { IFilter } from 'powerbi-models';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';

interface IPowerBIReport {
    iFilters: IFilter[];
    reportId: string;
    isAgentView?: boolean;
    enableRefresh: boolean;
    isSelected: boolean;
}

export default function PowerBIReport(props: IPowerBIReport) {
    const { get } = React.useContext(APIContext);
    const [pbiToken, setPbiToken] = React.useState('');
    const [tokenExpires, setTokenExpires] = React.useState('');
    const [embedURL, setEmbedURL] = React.useState<string>('');
    const [, setRefreshTimer] = React.useState<any>();
    const [report, setReport] = React.useState<Report | null>(null);
    const [refreshTime, setRefreshTime] = React.useState<string>('Last refreshed at ' + new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }));

    React.useEffect(() => {
        if (pbiToken) {
            generateEmbedURL();
        }
    }, [pbiToken]);

    React.useEffect(() => {
        getPBIToken();
    }, [props.reportId]);

    // The token is held in state only: as a cookie it rode on every API request, where the WAF logged it.
    const getPBIToken = async () => {
        if (tokenExpires !== "" && tokenExpires !== null) {
            setRefreshTimer(setTimeout(() => {
                onRefresh();
            }, 900000));
        }

        get('Report', `GetToken`, (data) => {
            setPbiToken(data);
            const expire = new Date();
            expire.setTime(expire.getTime() + 1 * 3600 * 1000); // 1 hour
            setTokenExpires(expire.toUTCString());
        });
    }

    const generateEmbedURL = () => {
        fetch('https://api.powerbi.com/v1.0/myorg/reports/' + props.reportId, {
            method: 'GET',
            headers: {
                'cache-control': 'no-store, must-revalidate, no-cache',
                'content-type': 'application/json; odata.metadata=minimal',
                'Authorization': 'Bearer ' + pbiToken
            }
        })
            .then(response => response.json())
            .then(embedData => {
                setEmbedURL(embedData.embedUrl);
                console.log('embedurl is ' + embedData.embedUrl)
            })
            .catch(error => { console.log('Report fetch error: ' + error.message); });
    }

    const onRefresh = () => {
        getPBIToken();
        pbiRefresh();
    }
    const pbiRefresh = () => {
        if (props.enableRefresh) {
            try {
                report!.refresh().catch(error => {
                    console.log(error);
                });
                setRefreshTime('Last refreshed at ' + new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }));
                console.log("Refreshed");
            }
            catch (errors) {
                console.log(errors);
            }
        }
    }

    return (
        !(props.reportId === "" || props.reportId === null) ?
            <>
                <div id="reportContainer" style={props.isSelected ? { height: '100%', display: 'flex', flexDirection: 'column' } : { width: '0px', height: '0px', visibility: 'hidden' }} >{/*Microsoft: "display CSS attribute is not set to 'none' as this can cause unexpected behaviors"*/}
                    <PowerBIEmbed
                        
                        embedConfig={{
                            type: 'report',
                            id: props.reportId,
                            embedUrl: embedURL,
                            accessToken: pbiToken,
                            tokenType: models.TokenType.Aad,
                            filters: props.iFilters,
                            settings: {
                                background: models.BackgroundType.Transparent,
                                visualSettings: {
                                    visualHeaders: [
                                        {
                                            settings: {
                                                visible: true
                                            }
                                        }
                                    ]
                                },
                                layoutType: models.LayoutType.Custom,
                                customLayout: {
                                    displayOption: models.DisplayOption.FitToPage,
                                },
                                panes: {
                                    filters: {
                                        visible: false
                                    },
                                    pageNavigation: {
                                        visible: false
                                    }
                                }
                            }
                        }}
                        eventHandlers={
                            new Map([
                                ['loaded', (event: any) => {
                                    console.log('Report loaded');
                                    setReport(event.srcElement.powerBiEmbed as Report);
                                }],
                                ['rendered', () => { console.log('Report rendered'); }],
                                ['error', (event: any) => {
                                    console.log(event);
                                    console.log(event.detail);
                                }],
                            ])
                        }
                    />
                </div>
                {props.enableRefresh &&
                    <Grid container justifyContent="flex-end" alignItems="center">
                        <Typography variant="subtitle2">{refreshTime}</Typography>
                        <Tooltip title="Report automatically refreshes every 15 minutes. Click to manually refresh.">
                            <IconButton color="secondary" onClick={pbiRefresh} size="small" >
                                <RefreshIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid >
                }
            </>
            :
            <Typography variant="h6">Report is not available. Please contact ResQ IT.</Typography>
    );
}